import React from "react";
import { Topbar } from "@components";
import { useNavigate } from "react-router-dom";
import { PUBLIC_ROUTE } from "@router/route.constants";
import styled from "styled-components";
import {
  AppleFilled,
  FacebookFilled,
  PlayStoreFilled,
  ViberFilled,
  YoutubeFilled,
  ApkFilled,
  TelegramFilled,
} from "@assets";
import { Space, Divider as AntDivider } from "antd";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const RootContainer = styled.div`
  min-height: 100vh;
  padding: 24px;
  text-align: center;

  svg {
    cursor: pointer;
  }
`;

const Title = styled.div`
  padding-bottom: 24px;
  font-size: 18px;
  font-weight: bold;
  color: #000000;
`;

const Divider = styled(AntDivider)`
  margin: 32px 0;
  border-block-start: 1px #ecb2e9 dashed !important;
`;

const AppDownload = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { social_links } = useSelector(state => state.app.settings);

  const goBack = () => {
    navigate(`/${PUBLIC_ROUTE.HOME}`);
  };

  const Link = ({ url, children }) => (
    <a href={url} target="_blank" rel="noreferrer noopen">
      {children}
    </a>
  );

  return (
    <>
      <Topbar title={t("home.appDownloadTitle")} goBack={goBack} />
      <RootContainer>
        <Title>{t("home.appDownloadSubTitle1")}</Title>
        <Space size={"middle"}>
          <Link url={social_links.fb_link}>
            <FacebookFilled />
          </Link>
          <Link url={social_links.viber_link}>
            <ViberFilled />
          </Link>
          <Link url={social_links.telegram_link}>
            <TelegramFilled />
          </Link>
          <Link url={social_links.youtube_link}>
            <YoutubeFilled />
          </Link>
        </Space>

        <Divider />

        <Title>{t("home.appDownloadSubTitle2")}</Title>
        <Space direction="vertical" size={"middle"}>
          <Link url={social_links.app_store_link}>
            <AppleFilled />
          </Link>
          <Link url={social_links.play_store_link}>
            <PlayStoreFilled />
          </Link>
          <Link url={social_links.download_link}>
            <ApkFilled />
          </Link>
        </Space>
      </RootContainer>
    </>
  );
};

export default AppDownload;
